import { InternalRefetchQueriesInclude } from '@apollo/client';
import {
  SmartLkPointsBindVideoStreamMutationInput,
  usePointsBindVideoStreamMutation,
} from 'domain/api/graphql/generated';
import { BaseMutationResultType, FetchPolicyKeys } from 'domain/api/graphql/types';

const useBindVideoStreamToPoints = () => {
  const [mutation, mutationResult] = usePointsBindVideoStreamMutation({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
  });

  const request = async (
    input: SmartLkPointsBindVideoStreamMutationInput,
    refetchQueries?: InternalRefetchQueriesInclude
  ) => {
    const mutationData = await mutation({
      variables: {
        input,
      },
      refetchQueries,
    });

    return {
      isOk: mutationData.data?.result?.ok,
      errors: mutationData.data?.result?.errors,
    };
  };

  const result: BaseMutationResultType = {
    error: mutationResult.error,
    loading: mutationResult.loading,
    called: mutationResult.called,
  };

  return { request, result };
};

export default useBindVideoStreamToPoints;
